var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isTooltip)?_c('span',{staticClass:"has-tooltip-left",attrs:{"data-tooltip":_vm.getModifiedBy}},[_c('fa-icon',{staticClass:"info",attrs:{"icon":"info-circle","size":"lg"}})],1):_c('span',{staticClass:"modified-by"},[_vm._v(_vm._s(_vm.getModifiedBy))])])
}
var staticRenderFns = []

export { render, staticRenderFns }